/* Suresh Peddavoora 10/26/2022 3075154998  Changed Text Field Variant from outlined to standard
Suresh Peddavoora 10/31/2022 3075154998  Changed class name for Text Fields
Raghu Arun Kumar 11/02/2022 3075154998  Responsive Alignment Fixes
Lalitha       11/9/2022  3075154998 Rename Button Clear to Reset
Prakash Gummala 11/10/2022 3075154998 Text Field Alignments for Desktop Resolution
*/
import React, {useState, useContext, useEffect} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import SearchDataManagerTable from './SearchDataManagerTable';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useSelector} from 'react-redux';
const SearchDataManagerContainer = ({
  setTabValue,
  setCode,
  handleClose,
  setSelectedMediaTypeName,
  mediaName,
  setMediaName,
  setIsCopyData,
  disableCopy,
  setDisableCopy,
  setUsageState,
  usageState,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [usage, setUsage] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  // const { isLoading, successMsg, errorMsg } = useSelector(({ printusage }) => printusage);
  const {usageMedial} = useSelector(({addMediaType}) => addMediaType);
  const [isUsage, setIsUsage] = useState(false);


  useEffect(() => {
    usage && usageMedial?.userMetrix === 'No' ?
      null :
      usage && usageMedial?.userMetrix === 'Yes' ?
        setTabValue(2) :
        null;

    deleteUsage && usageMedial?.userMetrix === 'No' ?
      (setUserMetrixDelete(false), setIsDelete(true)) :
      deleteUsage && usageMedial?.userMetrix === 'Yes' ?
        (setUserMetrixDelete(true), setIsUsage(true)) :
        null;
  }, [usageMedial]);

  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };
  const initialValues = {
    mediaTypeName: '',
    description: '',
  };

  const onClear = () => {
    const data = {
      mediaTypeName: '',
      description: '',
    };
    setSearchData(data);
  };

  return (
    <>
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
        >
          {(props) => {
            const {values, handleChange, handleBlur, handleReset} = props;
            return (
              <div className={classes.ruleGroupCard}>
                <Form autoComplete="off" noValidate>
                  <div className="standard-field-textfields">
                    <ErrorBoundaryForComponents>
                      <Grid container spacing={2}>
                        <Grid item sm={3} lg={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="standard"
                            placeholder={`Enter Code`}
                            label="Code"
                            name="code"
                            value={values.code}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item sm={6} lg={7} xl={4} className="form-group">
                          <TextField
                            margin="dense"
                            variant="standard"
                            name="description"
                            placeholder={`Enter Description`}
                            label="Description"
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item sm={3} lg={2} xl={4} className="form-group">
                          <div >
                            <Button
                              variant="outlined"
                              className={`reset-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                handleReset();
                                setSearchData({});
                                setSubmit(true);
                                onClear();
                              }}
                            >
                          Reset
                            </Button>
                            <Button
                              variant="outlined"
                              type="submit"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                            >
                          Search
                            </Button>
                          </div>
                        </Grid>
                      </Grid>

                    </ErrorBoundaryForComponents>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <SearchDataManagerTable
          setTabValue={setTabValue}
          mediaName={mediaName}
          setMediaName={setMediaName}
          searchData={searchData}
          setSearchData={setSearchData}
          handleClose={handleClose}
          setCode={setCode}
          setSelectedMediaTypeName={setSelectedMediaTypeName}
          submit={submit}
          setSubmit={setSubmit}
          disableCopy={disableCopy}
          setIsCopyData={setIsCopyData}
          setUsageState={setUsageState}
          usageState={usageState}
          setUsage={setUsage}
          setDeleteUsage={setDeleteUsage}
          userMetrixDelete={userMetrixDelete}
          isDelete={isDelete}
          setIsDelete={setIsDelete}
          isUsage={isUsage}
          setIsUsage={setIsUsage}
        />
      </div>
      {/* {isLoading && <PageLoader/>}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      {customError && <WarningSnackbar errorMsg={"This logic block is not being used anywhere"} />} */}


    </>
  );
};
export default SearchDataManagerContainer;
